import { Component, OnInit , Output, Input, EventEmitter, SimpleChanges} from '@angular/core';
import { UserManagmentService } from '../../user-managment.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@root/common/confirmation-dialog/confirmation-dialog.component';
import { Department } from './../department/department.model';
@Component({
  selector: 'app-department-list',
  templateUrl: './department-list.component.html',
  styleUrls: ['./department-list.component.scss'],
  providers: [UserManagmentService]
})
export class DepartmentListComponent implements OnInit {

  @Input() regionList = [];

  searchByName: string;

  departmentList : [];

  @Output() editChange  = new EventEmitter<any>();

  public regionMap: {[key:string] : string} = {};

  constructor(public userManagmentService: UserManagmentService,
    private errorHandler: ErrorHandler,
    private toastr: ToastrService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.readDepartment();
  } 

  ngOnChanges(changes: SimpleChanges){
    if(this.regionList){
      if(changes['regionList'] && this.regionList.length > 0){
        this.regionList.forEach(r=>{
          this.regionMap[r.regionName] = r.regionName;
        })
      }
    }
  }

  public readDepartment(){
    this.userManagmentService.getDeparmentList().subscribe(
      response => {
        if(response.status === 0){
          this.departmentList = response.data.list;
        }else{
          this.errorHandler.handleError(response);
        }
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public openDeleteDialog(role) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: role , mode: 'DEPARTMENT-DELETE'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.userManagmentService.deleteDepartment({ departmentId: result.data.id }).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readDepartment();
            } else {
              this.toastr.error(response.error.errorMessage);
            }
          },
          (error) => {
            this.toastr.error(error.errorMessage);
            
          }
        );
      }
    });
  }


  public onEditDepartment(department: Department){
    this.editChange.emit(department);
    this.scrollTop();
  }

  public scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

}
